import React from "react";
import BlogListItem from "./BlogListItem";
import img01 from "../../assets/img/blog/blog_img01.png";
import img02 from "../../assets/img/blog/blog_img02.png";
import img03 from "../../assets/img/blog/blog_img03.png";

const BlogList = () => {
  const blog_list = [
    {
      url: "/transforminghealthcarewithblockchain",
      src: img01,
      author: "Alextina",
      time: "Dec 28, 2022",
      comments: "03",
      title:
        "DIAG Token: Incentivizing Patient Engagement and Data Sharing",
      summary:
        "In today’s fast-paced, technology-driven world, healthcare is being reimagined—and DIAG Token is leading the way. As the utility token of the Diagnostica App, DIAG does more than facilitate transactions—it empowers patients, incentivizes engagement, and transforms data into better health outcomes.",

    },
    {
      url: "/AIblockchaininhealthcare",
      src: img02,
      author: "Alextina",
      time: "Dec 28, 2022",
      comments: "03",
      title: (
        <>
          Diag Token & AI: Revolutionizing Healthcare with Blockchain-Powered Intelligence

        </>
      ),
      summary:
        "In today’s fast-evolving world, the fusion of AI and blockchain is driving innovation across industries — and healthcare is no exception. At the forefront of this transformation stands Diag Token, the native utility token of the Diagnostica App, designed to power an ecosystem that’s reshaping the way we diagnose, treat, and manage musculoskeletal conditions.",

    },
    {
      url: "/DIAGtokenfuturehealthcarepayments",
      src: img03,
      author: "Alextina",
      time: "Dec 28, 2022",
      comments: "03",
      title: `The Future of Healthcare Payments: DIAG Token and Blockchain Integration`,
      summary:
        "In a world where healthcare is often plagued by high costs, administrative complexity, and lack of transparency, blockchain technology is emerging as a powerful force of change. At the forefront of this transformation is the DIAG Token, the native utility token of the Diagnostica App, redefining how we think about healthcare payments, engagement, and equity.",
    },
  ];

  return (
    <>
      {blog_list.map((blog, index) => (
        <BlogListItem key={index} item={blog} />
      ))}
    </>
  );
};

export default BlogList;
